import "./About.css";

export default function About() {
  return (
    <section className="about-page">

      <div className="about-header">
        <h1>Hakkımızda</h1>
        <div className="line"></div>

        <p>
          15 yılı aşkın deneyimimizle doğal taşın güzelliğini yaşam alanlarınıza taşıyoruz.
        </p>
      </div>

      <div className="story-box">
        <h2>Hikayemiz</h2>

        <p>
          Neva Mermer, 2008 yılında İstanbul’da küçük bir atölye olarak kuruldu.
          Kurucumuzun mermer ve doğal taşa olan tutkusu, bugün yüzlerce projeye
          imza atan bir firmaya dönüştü.
        </p>

        <p>
          Yıllar içinde edindiğimiz deneyim sayesinde sadece taş uygulaması değil,
          bütünsel bir dekorasyon deneyimi sunuyoruz.
        </p>
      </div>

      <div className="features">

        <div className="feature-card">
          <h3>Misyonumuz</h3>
          <p>
            Doğal taşın estetik gücünü yaşam alanlarına taşımak.
          </p>
        </div>

        <div className="feature-card">
          <h3>Değerlerimiz</h3>
          <p>
            Kalite, güven ve müşteri memnuniyeti odaklı çalışma.
          </p>
        </div>

        <div className="feature-card">
          <h3>Ekibimiz</h3>
          <p>
            Uzman ustalar ve deneyimli iç mimar ekibi.
          </p>
        </div>

        <div className="feature-card">
          <h3>Kalite Güvencesi</h3>
          <p>
            Her projede premium işçilik ve kaliteli malzeme.
          </p>
        </div>

      </div>

    </section>
  );
}